import React from 'react';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import { CustomTextField } from '../../../../components/CustomTextField';
import GeneralStepBody from "./GeneralStepBody";
import {InputAdornment} from "@mui/material";
import {EmailSubsectionChip} from "../../../../components/buttons/IconButtons";
import CustomOtpInput from "../../../../components/CustomOtpInput";
import {STEP_MODEL} from "../../Model/HomeModel";
import {toast} from "react-toastify";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 19 de 05 de 2026
 */

const OTPVerification = ({
                             t,
                             stepModel,
                             email,
                             minutes,
                             seconds,
                             canResendOtp,
                             handleValidateOtp,
                             otp,
                             setOtp,
                             handleResendOtp,
                             setIsValidOtp,
                             emptyFields,
                             isValidOtp}) => {


    return (
        <GeneralStepBody t={t} title='otp_code_verification'
                         description={
                             stepModel?.NAME === STEP_MODEL.EMAIL.NAME
                                 ? 'otp_code_sent_description'
                                 : 'enter_ientry_mobile_app_to_access_dynamic_access_token'
                         }>
            <div className='d-flex flex-column text-center gap-3 mt-3 w-100'>
                { stepModel?.NAME === STEP_MODEL.EMAIL.NAME &&
                    <>
                        <p className='fs-16px ibl-font-w-400 font-color-primary-600'>{email}</p>
                        <div className='border-full-shades-300 mt-3'/>
                        <p className='fs-16px ibl-font-w-500 font-color-shades-700 mt-3'>{t('enter_6_digit_code')}</p>

                    </>
                }
                <div className='d-flex align-items-center justify-content-center gap-2 mt-3'>
                    <CustomOtpInput
                        value={otp}
                        onChange={(newValue) => {
                            setOtp(newValue);
                            setIsValidOtp(true);
                        }}
                        onlyNumbers={true}
                        required={true}
                        emptyFields={emptyFields}
                        isValid={isValidOtp}
                    />
                </div>
                { stepModel?.NAME === STEP_MODEL.EMAIL.NAME ?
                    <>
                        <div className='d-flex align-items-center justify-content-center gap-2'>
                            <p className='fs-14px ibl-font-w-400 font-color-shades-700'>{t('expires_in')}</p>
                            <p className='fs-14px ibl-font-w-400 font-color-error-400 '>{`${minutes}:${seconds}`}</p>
                        </div>
                        <div className='d-flex align-items-center justify-content-center gap-2 mt-3'>
                            <p className='fs-14px ibl-font-w-400 font-color-shades-700 mb-0'>{t('didnt_get_the_code')}</p>
                            <p
                                className={`fs-16px ibl-font-w-400 mb-0 cursor-pointer font-color-primary-600`}
                                onClick={() => { if (canResendOtp)handleResendOtp();
                                    toast.info(t('only_can_resend_code_when_expires_code'))
                                }}
                            >
                                {t('resend_code')}
                            </p>
                        </div>
                    </> :
                    <p className='fs-16px ibl-font-w-500 font-color-shades-700 mt-3'>{t('check_your_mobile_app')}</p>

                }
                <div className='col-12 mt-3 p-0 w-100'>
                    <ButtonAction
                        id='btn_ov_forgot_password'
                        name={'verify'}
                        disabled={stepModel?.NAME === STEP_MODEL.EMAIL.NAME ? canResendOtp : false}
                        className='btn-icon-add w-100'
                        onClick={() => {
                            handleValidateOtp();
                        }}
                    />
                </div>
            </div>
        </GeneralStepBody>
    );
};

export default OTPVerification;
